import { useRequest } from '@hourly/hooks/useRequest';
import { useState } from 'react';
import { Partner } from '../models/partner.model';
import { editPartnerDetails } from '../requests/editPartnerDetails.request';
import { getPartnerDetails } from '../requests/partner.request';

export function usePartnerDetails(partnerId: string) {
  const [partner, setPartner] = useState<Partner | null>(null);

  const { request: fetchPartnerDetails, status } = useRequest(
    async () => {
      if (!partnerId) {
        return;
      }
      setPartner(await getPartnerDetails(partnerId));
    },
    { requestOnMount: true }
  );

  const { request: editPartner } = useRequest(async (partnerDetails: Partial<Partner>) => {
    if (!partnerDetails || !partnerId) {
      return;
    }
    await editPartnerDetails(partnerId, partnerDetails);
    fetchPartnerDetails();
  });

  return { partner, isFetchPartnerDetailsSettled: status.isError || status.isSuccess, editPartner };
}
